import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'concatenateString',
    standalone: false
})
export class ConcatenateStringPipe implements PipeTransform {

  constructor(public translateService: TranslateService) {}

  transform(value: string, appendString: string): string {
    if (!value || !appendString) {
      return value;
    }
    return `${value} ${appendString}`;
  }
}
